import type { FormField, Step } from '@/ts/types/schema.types'

export interface StepService {
  checkStepIsAvailable(steps: Array<Step>, stepId: number): boolean
  findStep(steps: Array<Step> | undefined, stepId: number | undefined, callback: Function): void
  findField(formSchema: Array<FormField>, fieldId: string, callback: Function): void
}

export const StepService: StepService = {
  checkStepIsAvailable(steps: Array<Step>, stepId: number): boolean {
    return steps.some((step: Step) => step?.step_id === stepId)
  },
  findStep(steps: Array<Step>, stepId: number, callback: Function): void {
    const step: Step | undefined = steps.find((step: Step) => step?.step_id === stepId)
    if (step) callback(step)
  },
  findField(formSchema: Array<FormField>, fieldId: string, callback: Function): void {
    const field: FormField | undefined = formSchema.find((field: FormField) => field?.config?.field_id === fieldId)
    callback(field)
  }
}
